// Get default local date (today) in YYYY-MM-DD format for HTML date input
export const getCurrentLocalDate = () => {
    const now = new Date();
    // Use local date components to avoid timezone issues
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

